<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-" id="_idParaDest-1">The Sunburned Corpse</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">A PI Steve Conacher Mystery</p>
<p class="ORIM-Author-Name--Front-Matter-">Lawrence Lariar</p>
<p class="ORIM-Author-Name--Front-Matter- _idGenParaOverride-1"><img src="image/logo3.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SunburnedCorpse2.vue?53371c26